import gql from "graphql-tag";

export const CustomGetStaffMyselfSimple = gql`
  query getStateMyself($langCd: String) {
    getStaffMyself {
      id_account
      access_id
      tenant_id
      name
      state
      role
      can_communicate_with_sms
      belongs {
        id
        staff_group {
          id
          name
          order_no
        }
        staff_group_id
        staff_id_account
      }
      tenant {
        id
        code
        tenant_type
        background_image
        custom_dictionary_id
        name
        names(langCd: $langCd) {
          id
          tenant_id
          dict_cd
          lang_cd
          message
        }
        location_groups {
          id
          name
        }
        currency {
          id
          ISO_code
          country
          currency_name
          currency_symbol
        }
        inquiry_reject_enabled
      }
      user {
        id_account
        access_id
        name
        lang_cd
        icon
        user_type
        email
        qr
        sign_up_at
        activation_type
        mode
        online_status
        notification_email
        notification_push
        is_official
        created_at
        updated_at
        sandbox_type
        responder_id
        responder_name
      }
    }
  }
`;
